<style lang="sass" scoped>
  @import '../../../sass/variables'
  .timeline.scroll
    height: 471px !important
    border-radius: 24px !important
    box-shadow: 0px 8px 24px rgba(0, 0, 0, 0.1)

  .fa-spin
    color: #71767D
    font-size: 1.5rem
    padding:24px

  .card
    height: 471px
    background-color: $salesflow-bg-content
    padding: 0px 4px 0px 4px

    .card-header
      padding:0
      h2
        font-size: 1.25rem
        font-weight: 700
        color: $salesflow-font-gray
        line-height: 120%
        padding-bottom: 12px

    .blur
      width: 93%
      height: 40px
      background-color: #fff
      filter: blur(35px)
      position: absolute
      bottom: 0

    .card-body
      padding: 0
      overflow: hidden
      overflow-y: scroll
      position: relative
      top: 0
      bottom: 100px
      margin-bottom: 7px

    .timeline-centered
      margin-top: 0

    .timeline-entry
      margin-right: 27px
      margin-left: 60px

    .empty
      top:35%
</style>
<template>
  <div class="timeline scroll with-shadow">
    <div class="card">
      <div class="card-header">
        <h2 class="float-left">
          {{ __('Últimas Atividades') }}
        </h2><i
          class="fa fa-circle-o-notch fa-spin float-right"
          v-if="loading"
        />
      </div>
      <div class="card-body">
          <DashboardEmptyData
            class="dashboard-empty-data"
            :content="__('Que tal criar uma atividade?')"
            v-if="!filteredTimeline.length"
          />
          <div v-if="filteredTimeline.length" class="timeline-centered mt-4">
            <article
              class="timeline-entry"
              v-for="(log, index) in filteredTimeline"
              :key="index"
            >
              <div class="timeline-entry-inner">
                <div class="timeline-icon">
                  <i :class="log.data.icon || log.icon" />
                </div>
                <div class="timeline-label">
                  <div
                    class="message"
                    v-html="log.message"
                  />
                  <div
                    class="time"
                    v-b-tooltip.bottom="formatDate(log.created_at)"
                  >
                    <span class="icon mr-1"><i class="fa fa-clock-o" /></span> {{ log.created_at | ago }}<span v-if="log.user"> por {{ log.user.first_name }}</span>
                  </div>
                </div>
              </div>
            </article>
          </div>
        </div>
        <div class="blur"></div>
      </div>
    </div>
</template>

<script>
import { VBTooltip } from 'bootstrap-vue';
import dayjs from '../../core/dayjs';
import Widget from '../../mixins/widget';

export default {
  directives: {
    'b-tooltip': VBTooltip,
  },

  store: ['users'],

  props: ['user'],

  mixins: [Widget],

  data () {
    return {
      name: 'activity',
      loading: true,
      error: false,
      data: {},
      user_id: '',
    };
  },

  computed: {
    filteredTimeline () {
      return _.filter(this.data, (log) => log.data.icon || log.icon);
    },
  },

  methods: {
    formatDate (date) {
      return dayjs(date).format('LDT');
    },
  },
};
</script>
